module.exports = __webpack_public_path__ + "static/media/buy_req_rent_2.e0772f72.jpg";